/**
 * Configuration cartographique du web client.
 *
 *   NEXT_PUBLIC_MAP_ASSETS_URL = base des styles et glyphes Fast
 *                                (défaut : https://map-assets.fastsvc.net)
 *   NEXT_PUBLIC_PHOTON_URL     = instance de géocodage (cf. lib/geocoding.ts)
 *   NEXT_PUBLIC_OSRM_URL       = serveur d'itinéraires (suivi livreur)
 *
 * Même pile que l'app client et que la console : MapLibre GL, tuiles
 * OpenFreeMap, styles Fast jour / nuit en BDO Grotesk, Photon, OSRM. Aucune
 * clé, aucun abonnement — le web partait sur Mapbox, avec un jeton exposé dans
 * chaque URL et une facturation à la requête, pour des cartes qui ne
 * ressemblaient pas à celles de l'app.
 */

export const MAP_ASSETS_URL = (
  process.env.NEXT_PUBLIC_MAP_ASSETS_URL ?? "https://map-assets.fastsvc.net"
).replace(/\/+$/, "");

/** Centre par défaut (Alger). */
export const DEFAULT_CENTER = { latitude: 36.7538, longitude: 3.0588 };
export const DEFAULT_ZOOM = 12;

/**
 * La carte est limitée à l'Algérie : tout ce qui est hors du pays est recouvert
 * d'un masque de la couleur du fond, et la caméra ne peut pas sortir des
 * bornes. Le masque est un polygone « monde entier » troué par la frontière
 * OSM, uni aux eaux côtières — le littoral et la baie d'Alger restent
 * lisibles, la Sardaigne non.
 *
 * Repris tel quel de la console pour rester cohérent d'un produit à l'autre.
 */
export const MAP_COUNTRY_MASK_URL = "/maps/dz-mask.json";
export const MAP_COUNTRY_BOUNDS = {
  west: -10.5,
  south: 17.5,
  east: 13.5,
  north: 38.5,
} as const;

/**
 * Les mêmes bornes au format plat `[ouest, sud, est, nord]`.
 *
 * `LngLatBoundsLike` accepte aussi une paire de points, mais depuis
 * react-map-gl 8.1.3 TypeScript n'arrive plus à trancher entre les deux formes
 * et réduit le littéral à `never`. La forme plate lève l'ambiguïté.
 */
export const MAP_MAX_BOUNDS: [number, number, number, number] = [
  MAP_COUNTRY_BOUNDS.west,
  MAP_COUNTRY_BOUNDS.south,
  MAP_COUNTRY_BOUNDS.east,
  MAP_COUNTRY_BOUNDS.north,
];

/**
 * Attribution des fonds de carte (licence ODbL).
 *
 * Rassemblée sur « Compte › À propos › Données cartographiques » plutôt que
 * répétée en surimpression de chaque carte, où elle mangeait un coin d'un
 * écran qui sert à lire une position.
 */
export const MAP_ATTRIBUTION = "OpenFreeMap © OpenMapTiles — données OpenStreetMap";

/** Serveur d'itinéraires pour le tracé livreur. */
export const OSRM_URL = (
  process.env.NEXT_PUBLIC_OSRM_URL ?? "https://router.project-osrm.org"
).replace(/\/+$/, "");
